import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const pains = [{
  icon: '📋',
  title: 'Firmaste sin leer',
  desc: 'Te pusieron un papel adelante bajo presión y firmaste sin saber lo que decía.'
}, {
  icon: '🏥',
  title: 'La ART te apura',
  desc: 'Te quieren dar el alta antes de tiempo y no sabés si podés rechazarla.'
}, {
  icon: '🏠',
  title: 'Tu propietario abusa',
  desc: 'Aumentos ilegales, reparaciones que no hace, presión para que te vayas.'
}, {
  icon: '💊',
  title: 'La obra social te niega',
  desc: 'Medicamentos, estudios, tratamientos. Siempre encuentran una excusa para no cubrir.'
}, {
  icon: '🏦',
  title: 'El banco te cobra de más',
  desc: 'Seguros que no pediste, comisiones ilegales, débitos que no autorizaste.'
}, {
  icon: '💼',
  title: 'Tu jefe te presiona',
  desc: 'Suspensiones, descuentos, o te hacen la vida imposible para que renuncies.'
}, {
  icon: '🔍',
  title: 'Googleás y no encontrás',
  desc: 'Artículos genéricos que no aplican a tu caso. Foros con consejos contradictorios.'
}, {
  icon: '⚖️',
  title: 'El abogado es caro y lento',
  desc: 'Te cobran la consulta, te hablan en otro idioma y no te dan nada concreto para hacer hoy.'
}];
export function PainPoints() {
  return <section className="py-12 md:py-[70px] px-5 bg-navy text-white" data-id="element-132">
      <div className="max-w-[860px] mx-auto" data-id="element-133">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-gold mb-2" data-id="element-134">
          ¿Te pasa esto?
        </div>
        <h2 className="font-display text-[clamp(28px,6vw,52px)] text-white mb-2 leading-tight" data-id="element-135">
          Si vivís en Argentina, esto te suena familiar
        </h2>
        <p className="text-[14px] md:text-[16px] text-white/65 max-w-[560px] mb-6 md:mb-9" data-id="element-136">
          El sistema cuenta con que no sabés tus derechos. Y en la mayoría de
          los casos, tiene razón.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-3 mb-8 md:mb-10" data-id="element-137">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} whileTap={{
          scale: 0.98
        }} whileHover={{
          x: 4,
          backgroundColor: 'rgba(201,168,76,0.08)'
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="flex items-center gap-3 md:gap-4 bg-white/5 hover:bg-white/8 border border-white/10 rounded-xl p-3 md:p-4 cursor-pointer group transition-colors" data-id="element-138">
              {/* Icon container */}
              <div className="flex-shrink-0 w-11 h-11 md:w-12 md:h-12 bg-gold/15 border border-gold/30 rounded-lg flex items-center justify-center text-xl md:text-2xl" data-id="element-139">
                {pain.icon}
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0" data-id="element-140">
                <h4 className="text-[14px] md:text-[15px] font-bold text-gold-light leading-tight mb-0.5" data-id="element-141">
                  {pain.title}
                </h4>
                <p className="text-[12px] md:text-[13px] opacity-70 leading-snug" data-id="element-142">
                  {pain.desc}
                </p>
              </div>

              <ArrowRight size={16} className="flex-shrink-0 text-gold/40 group-hover:text-gold group-hover:translate-x-0.5 transition-all" data-id="element-143" />
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-144">
          <p className="text-[15px] md:text-[18px] font-bold text-gold-light mb-2" data-id="element-145">
            ¿Cuántas veces más vas a perder un reclamo válido por no saber cómo
            presentarlo?
          </p>
          <small className="opacity-60 text-[12px] md:text-[14px]" data-id="element-146">
            La información correcta cambia todo. Y ahora está disponible.
          </small>
        </div>
      </div>
    </section>;
}